import { lazy, Suspense } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileCTABar } from "@/components/layout/MobileCTABar";
import { SEOHead } from "@/components/layout/SEOHead";
import { Hero } from "@/components/home/Hero";
import { CapabilityBand } from "@/components/home/CapabilityBand";
import { WhatsAppFloat } from "@/components/shared/WhatsAppFloat";

const BrandManifesto = lazy(() => import("@/components/home/BrandManifesto").then(m => ({ default: m.BrandManifesto })));
const PracticeAreaGrid = lazy(() => import("@/components/home/PracticeAreaGrid").then(m => ({ default: m.PracticeAreaGrid })));
const WhyMartinez = lazy(() => import("@/components/home/WhyMartinez").then(m => ({ default: m.WhyMartinez })));
const FeaturedResults = lazy(() => import("@/components/home/FeaturedResults").then(m => ({ default: m.FeaturedResults })));
const AttorneySpotlight = lazy(() => import("@/components/home/AttorneySpotlight").then(m => ({ default: m.AttorneySpotlight })));
const HowItWorks = lazy(() => import("@/components/home/HowItWorks").then(m => ({ default: m.HowItWorks })));
const Locations = lazy(() => import("@/components/home/Locations").then(m => ({ default: m.Locations })));
const ResourceStrip = lazy(() => import("@/components/home/ResourceStrip").then(m => ({ default: m.ResourceStrip })));
const FinalCTA = lazy(() => import("@/components/home/FinalCTA").then(m => ({ default: m.FinalCTA })));

const Index = () => {
  return (
    <>
      <SEOHead />
      <Header />
      <main id="main-content">
        <Hero />
        <CapabilityBand />
        <Suspense fallback={null}>
          <BrandManifesto />
          <PracticeAreaGrid />
          <WhyMartinez />
          <FeaturedResults />
          <AttorneySpotlight />
          <HowItWorks />
          <Locations />
          <ResourceStrip />
          <FinalCTA />
        </Suspense>
      </main>
      <Footer />
      <MobileCTABar />
      <WhatsAppFloat />
    </>
  );
};

export default Index;
